import React from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { Home } from "./components/home";
import { Kategory } from "./components/kategory/kategory.jsx";
import Subkat from "./components/subkat/index.jsx";
import ParameterTable from "./components/parameter/Parameter.jsx";
import Subresult from "./components/subresult/index.jsx";
import NotFound from "./components/error/not-found.jsx";

const Approuter = () => {
  return (
    <BrowserRouter >
      <Routes>
        <Route path="/" element={<Navigate to="/home" />} />
        <Route path="/kategory/:commo" element={<Kategory/>}/>
        <Route path="/sub-kategory/:id"element={<Subkat />}/>
        <Route path="/parameter-uji/:id"element={<ParameterTable/>}/>
        <Route path="/sub-result" element={<Subresult/>}/>
        <Route path="/home" element={<Home />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Approuter;
